import { COMPANY } from './seed-named';

/** Product family name each company sells in every line; offers and the P-85 catalog share it. */
export const PRODUCT_TIER: Record<string, string> = {
  [COMPANY.plata]: 'Plus',
  [COMPANY.austral]: 'Clásico',
  [COMPANY.federal]: 'Flex',
  [COMPANY.nexo]: 'Ágil',
  [COMPANY.pampa]: 'Pro',
  [COMPANY.litoral]: 'Protegido',
};
